import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject, catchError, filter, map, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ENDPOINT } from '../constants/app.constants';

export interface Downtime {
  isDown: boolean;
  downtimeMessage: string;
  lastUpdate?: string;
  updatedBy?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DowntimeService {

  downtime: WritableSignal<Downtime> = signal({
    isDown: false,
    downtimeMessage: '$$init$$'
  });
  downtimeEndpoint = environment.apiConfig.apiEndpointBase + API_ENDPOINT.DOWNTIME;

  _downtimeSubject = new BehaviorSubject({...this.downtime()});
  downtime$: Observable<Downtime>;

  constructor(private http: HttpClient) {
    this.downtime$ = this._downtimeSubject.asObservable().pipe(
      filter(d => d.downtimeMessage !== '$$init$$'),
    );
  }

  getDowntime() {
    this.http.get(this.downtimeEndpoint).pipe(
      map((resp: any) => resp.data),
      catchError(() => of({isDown:false, downtimeMessage: ''}))
    ).subscribe((data: Downtime) => {
      // console.log(data);
      this.downtime.set(data);
      this._downtimeSubject.next(data);
    })
  }

  setDowntime(newDowntime: Downtime) {
    return this.http.post(this.downtimeEndpoint, newDowntime).pipe(
      map((resp: any) => {
        return resp.data;
      }),
      tap((data: Downtime) => this.downtime.set(data))
    )
  }
}
